import type { AvatarGesture } from "../avatar";

/**
 * What Orla does when a phone visitor taps the picture, by where they tap. A phone has no
 * pointer to hover with, which is how she reacts on a wide screen, so the picture itself
 * answers instead. Positions are fractions of the hero, from its top left.
 *
 *   above her         she jumps, as if reaching for the finger
 *   on her            she waves back
 *   her name and ring she cheers
 *
 * Pressing and holding anywhere makes her run for as long as the finger stays down.
 */
export function gestureForTap(x: number, y: number): AvatarGesture {
  if (y < 0.3) return "Jump";
  if (x < 0.55) return "Wave";
  return "Cheer";
}

/** How long a finger must stay down before a tap becomes a hold, in milliseconds. */
export const HOLD_AFTER_MS = 320;
